<template>
    <div>
        <div class="flex center-xs space-top-1 space-bottom-2">
            <div class="flex start-xs vertical-center input-container" >
                <div v-for="(value, index) in step.valueList" :key="value" class="radio-wrapper">
                    <input @keyup.enter="keycheck" v-model="inputData" type="radio" class="hidden" :value="value" :id="step.name + index">
                    <label @keyup.enter="keycheck" class="radio-box" :for="step.name + index" tabindex="0">
                        <div class="mark-box flex start-xs">
                            <span class="radio-check-circle"></span>
                            <div class="radio-value">{{ value }}</div>
                        </div>
                    </label>
                </div>
                <div v-if="dipslayErrorMessage" class="red-text space-top-2">{{step.errorMessage}}</div>
            </div>
        </div>

        <ButtonSection
            :inputValid="inputValid"
            :order="order"
            :buttonText="step.buttonText"
            v-on:progress="handleProgress"
            v-on:back="$emit('back')"
        />
    </div>
</template>

<script>
import { minLength, required } from 'vuelidate/lib/validators';

import ButtonSection from './ButtonSection.vue';

export default {
    props: ['step', 'order'],
    components: {
        ButtonSection
    },
    data() {
      return {
          dirty: false
      }
    },
    validations: {
        inputData: {
            required,
            minLength: minLength(1)
        }
    },
    computed: {
        inputData: {
            get () {
                return this.$store.state.formFields[this.step.name];
            },
            set (value) {
                const name = this.step.name;
                this.dirty = true;
                this.$store.commit('updateField', { name, value })
            }
        },
        inputValid() {
            return !this.$v.inputData.$invalid;
        },
        displayErrorMessage() {
            return this.$v.inputData.$invalid && this.dirty;
        }
    },
    watch: {
        step: function() {
            // If there are two consecutive Radio, make sure dirty is reset
            this.dirty = false;
        }
    },
    methods: {
        handleProgress(){
            this.$emit('progress', this.step.name);
        },
        keycheck(e) {
            if (e.keyCode === 13 && this.inputValid) {
                this.$emit('progress', this.step.name);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.radio-value {
    display: inline-block;
    margin-left: 15px;
}

.mark-box {
    margin-top: 15px;
    position: relative;
}

.radio-check-circle {
    margin-top: 3px;
    height: 15px;
    width: 15px;
    color: #0384FB;
    background-color: #fff;
    border-radius: 50%;
    display: inline-block;

    &:after {
        width: 25px;
        height: 25px;
        content: "";
        border: 1px solid #BCBCBC;
        position: absolute;
        border-radius: 15px;
        display: block;
        left: -5px;
        top: -2px;
    }
}

.radio-wrapper {
    display: inline-block;
    position: relative;
    width: 100%;
}

label {
    background: #fcb608;
    padding: 2px 10px 2px 1.5em;
    border: 1px solid transparent; /* keeps layout from jumping */
}

input[type="radio"]:checked + label {
    border: 3px solid #0384FB;
    box-sizing: border-box;

    &>.mark-box>.radio-check-circle {
        margin-top: 3px;
        height: 15px;
        width: 15px;
        color: #0384FB;
        background-color: #0384FB;
        border-radius: 50%;
        display: inline-block;

        &:after {
            width: 25px;
            height: 25px;
            content: "";
            border: 1px solid #BCBCBC;
            position: absolute;
            border-radius: 15px;
            display: block;
            left: -5px;
            top: -2px;
        }
    }
}

.radio-box {
    margin: 5px 0;
    max-width: 588px;
    width: 100%;
    height: 60px;
    background: #FFFFFF;
    border: 1px solid #E7E7E7;
    box-sizing: border-box;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}
</style>